import { type QueryResolvers } from '../../../../generated/graphql'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import { getTempLayouts } from '../../../../Stores'

export const tempLayoutsResolver: QueryResolvers<ApolloResolverContext>['tempLayouts'] = async () => {
    console.debug('io-dashboards tempLayoutsResolver deprecated, use tempLayouts store')

    const layouts = getTempLayouts()
    return layouts
}
